import { Inject, Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { IAddonFacebookSdkConfig } from '../facebook.interface';
import { AddonPageAddonsRenderer } from '../../../shared/page-addons-renderer.helper';
import { EnumAddonPageAddonInjection, IAddonAddOnScriptScript } from '../../../shared/page-addons.interface';


@Injectable()
export class AddonFacebookLoginScript implements IAddonAddOnScriptScript {


	constructor(
		@Inject(EnumAddonPageAddonInjection.FacebookSocialConfig)
		private config			: IAddonFacebookSdkConfig,
		private rendererHelper	: AddonPageAddonsRenderer
	) {}


	create(): AddonFacebookLoginScript {

		//0 - check if config is set
		if (Util.String.isEmpty(this.config.pageId)) throw new Error(`AddonFacebookLoginScript => create => FATAL ERROR: the facebookAppId of "${this.config.pageId}" can not be empty`);

		//1 - define the scripts
		// cspell:disable
		const scriptInnerHtml: string = `
			window.fbAsyncInit = function() {
				FB.init({
					appId	: ${this.config.pageId},
					cookie	: true,
					xfbml	: true,
					version	: 'v13.0',
				});
			};
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				js = d.createElement(s); js.id = id;
				js.src = "https://connect.facebook.net/en_US/sdk.js";
				js.onload = function(){
					FB.Event.subscribe('auth.statusChange', (response) => {
						window.FBLoginOnSubmit$.next(response.authResponse.accessToken);
					});
				}
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		`;
		// cspell:enable

		//2 - add everything to the html
		this.rendererHelper.addScriptToHead('facebook_sdk', { innerHTML: scriptInnerHtml });
		return this;
	}
}
